import { DeleteColumnOutlined, DeleteRowOutlined, EditFilled, PlusCircleFilled } from '@ant-design/icons';
import { Button, Form, Modal, Popconfirm, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import _Api from 'services/Api/_Api';
import { Button_, Input_, Kotak, Number_, Select_ } from 'services/Forms/FormsSatu';
import { deleteUndefined } from 'services/Forms/function';
import { msg } from 'services/Toastr/Notify/_Toastr';


function InputMakananSehari(pr) {

    const [openModal, setopenModal] = useState(false);
    const [data, setdata] = useState([]);
    const [frm] = Form.useForm()
    const [selectedRowKey, setSelectedRowKey] = useState(null);



    const openCloseModal = () => {
        setopenModal(b => !b);
    };
    const tambahData = () => {
        setopenModal(b => !b);
        frm.resetFields()
    };
    const simpanData = () => {
        const val = frm.getFieldsValue()
        const obj = { ...deleteUndefined(val), konseling_id: pr.konseling_id, waktumakan_id: pr.waktumakan_id }
        _Api.post("simpan-form-hidangan-sehari", obj).then(g => {
            if (g.data.sts == 1) {
                getData()
                frm.resetFields()
                if (val.id != "") setopenModal(false)
                msg.auto(g.data)
            }
        })
    };
    const getData = () => {
        const val = frm.getFieldsValue()
        _Api.get("get-form-hidangan-sehari?konseling_id=" + pr.konseling_id + "&waktumakan_id=" + pr.waktumakan_id).then(g => {
            setdata(g.data)
        })
    };
    const hapusData = (rc) => {
        _Api.get("hapus-hidangan-sehari?id=" + rc.id).then(g => {
            msg.auto(g.data)
            if (g.data.sts == 1) {
                getData()
            }
        })
    };

    useEffect(() => {
        getData()
    }, [])
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: "70px",
            align: "center",
            render: (a, i, j) => (
                <div> {j + 1}  </div>
            )
        },
        {
            title: 'Makan Pagi',
            width: "400px",
            dataIndex: 'jenismakanan',
            key: 'jenismakanan',
            render: (a, i, j) => (
                <div> {i.jenismakanan}
                    <Button type='link' style={{ color: "orange", fontWeight: "bold" }} onClick={() => editData(i)} icon={<EditFilled />} />
                    <Popconfirm
                        title={"Hapus makanan " + i.jenismakanan + " ?"}
                        onConfirm={() => hapusData(i)}
                        // onCancel={cancel}
                        okText="Ya, Hapus"
                        cancelText="Batal">
                        <Button type='link' style={{ color: "red" }} icon={<DeleteRowOutlined />} />
                    </Popconfirm>
                </div>
            )
        },
        {
            title: 'Banyak',
            children: [
                {
                    title: 'Gr',
                    dataIndex: 'jlh_makan_gr',
                    key: 'jlh_makan_gr',
                    width: "100px",
                },
                {
                    title: 'URT',
                    dataIndex: 'jlh_makan_urt',
                    key: 'jlh_makan_urt',
                    width: "100px",
                },
            ]

        },
        {
            title: 'Selingan Pagi',
            dataIndex: 'selingan',
            width: "400px",
            key: 'selingan',
        },
        {
            title: 'Banyak',
            width: "300px",
            children: [
                {
                    title: 'Gr',
                    dataIndex: 'jlh_selingan_gr',
                    key: 'jlh_selingan_gr',
                    width: "100px",
                },
                {
                    title: 'URT',
                    dataIndex: 'jlh_selingan_urt',
                    key: 'jlh_selingan_urt',
                    width: "100px",
                },
            ]

        },
    ];
    const handleRowClick = (record) => {
        // setSelectedRowKey(record.id);
    };
    const editData = (rc) => {
        frm.setFieldsValue(rc)
        setopenModal(true)
    };

    return (
        <div className='mt-3'>
            <h4> <b>{pr.waktumakan} </b></h4>
            <Row>
                <Col>
                    <Button_ onClick={tambahData} icon={<PlusCircleFilled />} label="Tambah" />
                </Col>
                <Col sm="12">
                    {
                        openModal &&
                        <Form form={frm} layout='vertical' className='mb-2 border p-2 mt-1 bg-warning' >
                            <Row>
                                <Select_ required option={pr.combo && pr.combo.jenismakanan} sm="7" label="Jenis Makanan" val="id" caption="jenismakanan" name="jenismakanan_id" />
                                <Number_ required sm="2" label="Banyak (Gram)" name="jlh_makan_gr" />
                                <Number_ required sm="3" label="Banyak (URT)" name="jlh_makan_urt" />
                            </Row>
                            <Row>
                                <Select_ option={pr.combo && pr.combo.jenismakanan} sm="7" label="Selingan"
                                    val="id" caption="jenismakanan" name="selingan_id" />
                                <Number_ sm="2" label="Banyak (Gram)" name="jlh_selingan_gr" />
                                <Number_ sm="3" label="Banyak (URT)" name="jlh_selingan_urt" />
                            </Row>
                            <Row>
                                <Button_ label="Simpan" sm="2" onClick={simpanData} block />
                                <Button_ label="Tutup" danger onClick={openCloseModal} sm="2" block />
                                <Input_ hidden name="id" sm="1" />
                            </Row>
                        </Form>
                    }

                </Col>
            </Row>
            <Table size='small'
                onRow={(record) => ({
                    onClick: () => handleRowClick(record), // Tangani klik baris
                })}
                pagination={false} bordered dataSource={data} columns={columns} />



        </div>
    )
}

export default InputMakananSehari